import { render, staticRenderFns } from "./RemuneracaoSuporteContratosRightNavBar.vue?vue&type=template&id=5713db1b"
import script from "./RemuneracaoSuporteContratosRightNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoSuporteContratosRightNavBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports